import { useBusiness } from '../context/BusinessContext';
import PageHeader from '../components/PageHeader';
import Jobs from './Jobs';
import FlightJobs from './FlightJobs';

// The Jobs area behaves differently per business: SIM360 doesn't use it,
// Not My Airplane (B3) logs Flights, everyone else uses standard Jobs.
export default function JobsRoute() {
  const { activeBusiness } = useBusiness();
  const short = activeBusiness?.short;
  if (short === 'S360') {
    return (
      <>
        <PageHeader title="Jobs" />
        <section className="panel" style={{ padding: 20 }}>
          <p className="hint">Jobs aren’t used for SIM360.</p>
        </section>
      </>
    );
  }
  if (short === 'B3') return <FlightJobs />;
  return <Jobs />;
}
